module.exports = __webpack_public_path__ + "static/wiki-96af41bcfdc8bcb956ac75f5521fa7b3.png";